import { BaSeLoadingPage } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useModuleController } from '../../../../hooks/controllers/module-public-controller';
import { CandidateWithInterview } from '../../components/candidate-interview/candidate-with-interview';
import { CandidateWithoutInterview } from '../../components/candidate-interview/candidate-without-interview';

const resolverLoading = (loading, interview) => {
  if (loading) {
    return <BaSeLoadingPage />;
  }

  if (!interview) {
    return <CandidateWithoutInterview />;
  }
};

export const CandidateInterview = () => {
  const { isAuthenticated, login } = Sebrae.useAuth();
  const { navigateTo, getRouteParam } = Sebrae.useSebraeRouter();

  const [interview, setInterview] = React.useState();
  const [settingsModule, setSettingsModule] = React.useState();
  const [isAdmAccess, setIsAdmAccess] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const { getSettingsModule } = useModuleController();
  const { findInterviewByUserAuth, findInterviewByAdministratorAuth } =
    useInterviewController();

  const findModule = React.useCallback(
    (moduleId) => {
      moduleId &&
        getSettingsModule(moduleId).then((settings) => {
          setSettingsModule(settings);
        });
    },
    [getSettingsModule],
  );

  const findInterview = React.useCallback(
    (idInterview) => {
      if (idInterview) {
        setIsAdmAccess(true);
        findInterviewByAdministratorAuth(idInterview)
          .then((interview) => {
            setInterview(interview);
            findModule(interview.module.id);
          })
          .catch(() => navigateTo('/candidato'))
          .finally(() => setLoading(false));
        return;
      }

      findInterviewByUserAuth()
        .then((interview) => {
          setInterview(interview);
          findModule(interview?.module.id);
        })
        .finally(() => setLoading(false));
    },
    [
      findInterviewByUserAuth,
      findInterviewByAdministratorAuth,
      findModule,
      navigateTo,
    ],
  );

  React.useEffect(() => {
    !isAuthenticated && login();
    findInterview(getRouteParam('id'));
  }, [findInterview, getRouteParam, isAuthenticated, login]);

  return (
    resolverLoading(loading, interview) ?? (
      <CandidateWithInterview
        interviewId={interview?.id}
        moduleId={interview?.module.id}
        settingsModule={settingsModule}
        isAdmAccess={isAdmAccess}
      />
    )
  );
};
